// Where a visitor first came from (referring site, landing page, utm tags), kept in localStorage
// from their first page view so the sign-up event can say which channel brought them.
const KEY = 'firstTouch';

export function parseFirstTouch(href, referrer) {
  const url = new URL(href);
  let ref = '';
  try {
    const host = referrer ? new URL(referrer).hostname.replace(/^www\./, '') : '';
    if (host && host !== url.hostname.replace(/^www\./, '')) ref = host;
  } catch {
    // unreadable referrer: treat as direct
  }
  const q = url.searchParams;
  return {
    ref: ref || 'direct',
    landing: url.pathname.slice(0, 100),
    utmSource: (q.get('utm_source') || '').slice(0, 60),
    utmMedium: (q.get('utm_medium') || '').slice(0, 60),
    utmCampaign: (q.get('utm_campaign') || '').slice(0, 60),
  };
}

export function rememberFirstTouch() {
  try {
    if (localStorage.getItem(KEY)) return;
    localStorage.setItem(KEY, JSON.stringify(parseFirstTouch(window.location.href, document.referrer)));
  } catch {
    // storage unavailable: no attribution for this visitor
  }
}

export function getFirstTouch() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || 'null') || {};
  } catch {
    return {};
  }
}
